import React from 'react';

const CustomWoowiiTalentCompanyButton = ({ groupType, buttonType, color }) => {
    return (
        <div className={`download-button-group ${groupType}`}>
            <a  href="#talento-section-id" className={`woowii-hero-button-talento mb-5 download-button download-button-google ${buttonType}`}>
                <div className={`download-button-inner ${color}`}>
                    <div className="download-button-content">
                        <h3 className={`c-dark ls-2 ${color} ps-4 pe-4`}>SOY TALENTO</h3>
                    </div>
                </div>
            </a>
            <a href="#company-section-id" className={`download-button download-button-apple ${buttonType}`}>
                <div className={`download-button-inner ${color}`}>
                    <div className="download-button-content">
                        <h3 className={`c-dark ls-2 ${color} ps-4 pe-4`}>SOY EMPRESA</h3>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default CustomWoowiiTalentCompanyButton;